// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_ImportResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/anticipations/import/{subaccount_id}
 *
 * Returns the batch import result from AnticipationSyncService::importFromProvider().
 * The shape is the fixed `$results` accumulator built in that method:
 * total/imported/updated/skipped counts plus a list of error message strings.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_ImportResponseDados {
total: number
imported: number
updated: number
skipped: number
errors: string[]
}

export type SubaccountsAnticipations_ImportResponse = ApiResponse<SubaccountsAnticipations_ImportResponseDados>;

registerResponseContract('SubaccountsAnticipations_ImportResponse', {
  total:    { type: 'number',  required: true },
  imported: { type: 'number',  required: true },
  updated:  { type: 'number',  required: true },
  skipped:  { type: 'number',  required: true },
  errors:   { type: 'array',   required: true },
})
